<template>
  <v-container class="learn-more-container">
    <v-row no-gutters class="mt-4">
      <v-col cols="12">
        <router-link
          :to="{ name: 'InsuranceProducts' }"
          class="d-flex align-center text-decoration-none font-weight-bold"
          ><v-icon color="primary" class="mr-1">{{ icons.mdiArrowLeft }}</v-icon
          >Back</router-link
        >
      </v-col>
    </v-row>
    <v-row no-gutters class="mt-4">
      <v-col cols="12">
        <v-row no-gutters>
          <h1 class="quote-title text-decoration-underline estate">estate</h1>
          <h1 class="font-weight-medium">assist</h1>
        </v-row>
        <p class="mt-4">
          It is important to think about your family and to have everything
          ready should you pass away. Old Mutual Estate Assist insurance options
          are there to assist your loved ones when you are no longer able to.
        </p>
        <p class="font-weight-bold mb-0">What is an estate?</p>
        <p>
          All the property (money, cars, or houses) that you leave behind when
          you pass away will become your estate.
        </p>
      </v-col>
    </v-row>

    <v-row no-gutters class="mt-4" id="edu-assist">
      <v-col cols="12">
        <v-row no-gutters>
          <h2 class="quote-title text-decoration-underline edu">edu</h2>
          <h2 class="font-weight-medium">assist</h2>
        </v-row>
        <p class="mt-4">
          Parents are concerned about the future and education of their
          children. Ensuring your children can continue with their education
          without financial concerns in the event of your death is important. If
          your family is dependent on your income for your children’s school
          fees, you may want to consider EduAssist.
        </p>
        <p>
          EduAssist will make sure your children’s future is protected and they
          get the education they deserve.
        </p>
        <p class="font-weight-bold mb-0">How much cover can I get?</p>
        <p>
          You can get between R 5 000 and R 150 000 cover per year per child.
          The amount you have chosen will be paid out each year. This cover can
          be used towards school fees, uniforms, stationery and transport. The
          amount chosen should cover the costs of your children’s school
          education and related expenses.
        </p>
        <p class="font-weight-bold mb-0">
          How many children does EduAssist cover?
        </p>
        <p>
          There is no limit to the number of children you can include, however
          the total cover amount across all the Estate Assist products cannot
          exceed R 2.5 million.
        </p>
        <p class="font-weight-bold mb-0">When will the benefit be paid out?</p>
        <p>
          The amount you have chosen will be paid out each January until the
          year the covered child turns 18 (which is expected to be their matric
          year).
        </p>
        <p class="font-weight-bold mb-0">Who will the benefit be paid to?</p>
        <p>
          In the event of your death, the sum assured will be paid to your
          nominated guardian or into a testamentary trust. The amount you have
          chosen will be paid out each year from the year in which the covered
          child turns 7, until the year in which the child turns 18. Payment
          will follow a successful claims assessment.
        </p>
        <p class="font-weight-bold mb-0">How will the monthly payments work?</p>
        <p>
          Premiums will not change for the first year. After that your monthly
          payments are expected to increase by 6% annually.
        </p>
        <p class="font-weight-bold mb-0">Do I qualify for EduAssist?</p>
        <p>
          If you are a parent between 18 and 65 years old, have an SA ID number,
          and any of your children that are currently under the age of 16 years,
          you qualify for this cover.
        </p>
        <p class="font-weight-bold mb-0">When will EduAssist not pay out?</p>
        <p>If you take your own life(suicide), then you will not be covered.</p>
      </v-col>
    </v-row>

    <v-row no-gutters class="mt-4" id="cost-assist">
      <v-col cols="12">
        <v-row no-gutters>
          <h2 class="quote-title text-decoration-underline cost">cost</h2>
          <h2 class="font-weight-medium">assist</h2>
        </v-row>
        <p class="mt-4">
          There could be unplanned legal and admin costs when you die, such as
          moving a house from your name to your partner’s name. If there is no
          money available in your estate to pay for these costs, they might have
          to sell some of the items in your estate (such as a house, a car or
          other goods) to cover the costs.
        </p>
        <p>
          To prepare for this, the CostAssist cover will make sure there is
          money available to pay the estate costs.
        </p>
        <p class="font-weight-bold mb-0">How much cover will can I get?</p>
        <p>
          Cover can be anything between R 20 000 and R 750 000. We will
          calculate the legal and admin costs against your estate and provide
          that as a quote for you to accept. The cover amount you choose will
          stay the same unless you ask to make it more, up to a maximum of R 1
          200 000.
        </p>
        <p class="font-weight-bold mb-0">How will the monthly payments work?</p>
        <p>
          Premiums will not change for the first year. After that your monthly
          payments are expected to go up by 6% annually. These monthly payments
          will go off by debit from your account. If you stop paying the monthly
          payments, your cover will stop.
        </p>
        <p class="font-weight-bold mb-0">Do I qualify for CostAssist?</p>
        <p>
          If you are between 18 and 75 years old and have an SA ID number, you
          qualify for this cover.
        </p>
        <p class="font-weight-bold mb-0">When will CostAssist not pay out?</p>
        <p>If you take your own life(suicide), then you will not be covered.</p>
      </v-col>
    </v-row>
    <v-row no-gutters class="mt-4" id="debt-assist">
      <v-col cols="12">
        <v-row no-gutters>
          <h2 class="quote-title text-decoration-underline debt">debt</h2>
          <h2 class="font-weight-medium">assist</h2>
        </v-row>
        <p class="mt-4">
          In the event of your death, there could still be money owing on your
          house or your car. If there is no money available in your estate to
          pay for these debts or loans, they might have to sell some of the
          items in your estate (such as a house, a car or other goods) to pay
          for it.
        </p>
        <p>
          To prepare for this, DebtAssist will make sure there is money
          available to settle the debt amounts you have listed in your Old
          Mutual Digital Will.
        </p>
        <p class="font-weight-bold mb-0">How much cover will I need?</p>
        <p>
          Cover can be anything between R 50 000 and R 1 200 000. We will
          calculate your total debt and provide that as a quote. The cover
          amount you choose will stay the same unless you ask to make it more,
          up to a maximum of R 1 200 000.
        </p>
        <p class="font-weight-bold mb-0">How will the monthly payments work?</p>
        <p>
          Premiums will not change for the first year. After that your monthly
          payments are expected to go up by 6% annually. These monthly payments
          will go off by debit from your account. If you stop paying the monthly
          payments, your cover will stop.
        </p>
        <p class="font-weight-bold mb-0">Do I qualify for DebtAssist?</p>
        <p>
          If you are between 18 and 75 years old and have an SA ID number, you
          qualify for this cover.
        </p>
        <p class="font-weight-bold mb-0">When will DebtAssist not pay out?</p>
        <p>If you take your own life(suicide), then you will not be covered.</p>
      </v-col>
    </v-row>
    <v-row no-gutters class="mt-4" id="cash-assist">
      <v-col cols="12">
        <v-row no-gutters>
          <h2 class="quote-title text-decoration-underline cash">cash</h2>
          <h2 class="font-weight-medium">assist</h2>
        </v-row>
        <p class="mt-4">
          If you pass away your family may need money to survive on while the
          estate is being finalised. If there is no money available in your
          estate to help your family at this time, they will not be able to pay
          their day-to-day expenses or buy food and clothes.
        </p>
        <p>
          To prepare for this, CashAssist will make sure there is money
          available for your family to live on while the estate is being wrapped
          up.
        </p>
        <p class="font-weight-bold mb-0">How much cover will I need?</p>
        <p>
          Cover can be anything between R 30 000 and R 300 000. The amount
          chosen should at least cover about 3 months of your current expenses.
          The money for CashAssist will pay out within two weeks of all required
          documents being submitted.
        </p>
        <p class="font-weight-bold mb-0">How will the monthly payments work?</p>
        <p>
          Premiums will not change for the first year. After that your monthly
          payments are expected to go up by 6% annually. These monthly payments
          will go off by debit from your account. If you stop paying the monthly
          payments, your cover will stop.
        </p>
        <p class="font-weight-bold mb-0">Do I qualify for CashAssist?</p>
        <p>
          If you are between 18 and 75 years old and have an SA ID number, you
          qualify for this cover.
        </p>
        <p class="font-weight-bold mb-0">When will CashAssist not pay out?</p>
        <p>If you take your own life(suicide), then you will not be covered.</p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'LearnMore',
  };
</script>

<style lang="scss">
  .learn-more-container {
    .edu {
      color: var(--v-education-blue-base);
    }
    .cost {
      color: var(--v-cost-orange-base);
    }

    .cash {
      color: var(--v-cash-green-base);
    }

    .debt {
      color: var(--v-debt-brown-base);
    }

    .estate {
      color: var(--v-estate-pink-base);
    }

    h1 {
      font-size: 40px;
    }

    h2 {
      font-size: 24px;
    }

    p {
      font-size: 20px;
    }
  }
</style>
